export const getPriorityBadgeColor = (priority) => {
  switch (priority?.toLowerCase()) {
    case "high":
      return "danger";
    case "medium":
      return "warning";
    case "low":
      return "success";
    default:
      return "secondary";
  }
};

export const getStatusBadgeColor = (status) => {
  switch (status?.toLowerCase()) {
    case "assigned":
      return "primary";
    case "work_started":
      return "info";
    case "work_completed":
      return "warning";
    case "resolved":
      return "success";
    case "closed":
      return "secondary";
    default:
      return "light";
  }
};
